// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AbstractViewModel } from '@front/webmobile/ViewModels/AbstractViewModel';
import { AccountWidgetAccountDetailsPanelController } from '@shared/commons/AccountWidget/AccountWidgetAccountDetailsPanelController';
import { RowItemDataColorArray } from '@shared/commons/cache/VerticalPanel/AccountDetails/RowItemData';
export class AccountWidgetItemProps {
}
export class AccountWidgetItemComponentView {
}
export class AccountWidgetItemViewModel extends AbstractViewModel {
    get header() {
        return this.componentView.header;
    }
    set header(value) {
        this.updateComponentView('header', value);
    }
    get firstValue() {
        return this.componentView.firstValue;
    }
    set firstValue(value) {
        this.updateComponentView('firstValue', value);
    }
    get firstValueColor() {
        return this.componentView.firstValueColor;
    }
    set firstValueColor(value) {
        this.updateComponentView('firstValueColor', value);
    }
    get secondValue() {
        return this.componentView.secondValue;
    }
    set secondValue(value) {
        this.updateComponentView('secondValue', value);
    }
    get secondValueColor() {
        return this.componentView.secondValueColor;
    }
    set secondValueColor(value) {
        this.updateComponentView('secondValueColor', value);
    }
    get tooltip() {
        return this.componentView.tooltip;
    }
    set tooltip(value) {
        this.updateComponentView('tooltip', value);
    }
    get hovered() {
        return this.componentView.hovered;
    }
    set hovered(value) {
        this.updateComponentView('hovered', value);
    }
    constructor() {
        super(AccountWidgetItemComponentView);
        this.UpdateData = this.UpdateData.bind(this);
        this.UpdateRelations = this.UpdateRelations.bind(this);
        this.Validate = this.Validate.bind(this);
    }
    initialize(props) {
        super.initialize(props);
        this.props = props;
        this.tileType = props.tileTypePointer.ItemType;
        this.tileKey = props.tileTypePointer.Key;
        this.props.subscribeOnUpdateDataEvent(this.UpdateData);
        this.props.subscribeOnUpdateRelationsEvent(this.UpdateRelations);
        this.props.subscribeOnValidateEvent(this.Validate);
        this.updateController(props.tileTypePointer.GroupType);
        this.UpdateRelations();
    }
    update(props) {
        super.update(props);
        if (this.props.tileTypePointer.GroupType !== props.tileTypePointer.GroupType) {
            this.updateController(props.tileTypePointer.GroupType);
        }
        if (this.tileType !== props.tileTypePointer.ItemType || this.tileKey !== props.tileTypePointer.Key) {
            this.tileType = props.tileTypePointer.ItemType;
            this.tileKey = props.tileTypePointer.Key;
            this.UpdateRelations();
        }
        this.props = props;
    }
    dispose() {
        this.props.unsubscribeOnUpdateDataEvent(this.UpdateData);
        this.props.unsubscribeOnUpdateRelationsEvent(this.UpdateRelations);
        this.props.unsubscribeOnValidateEvent(this.Validate);
        super.dispose();
    }
    UpdateRelations() {
        if (isNullOrUndefined(this.controller)) {
            return;
        }
        this.Validate();
        this.UpdateData();
    }
    UpdateData() {
        if (isNullOrUndefined(this.controller)) {
            return;
        }
        const controller = this.controller;
        const itemType = this.tileType;
        const itemKey = this.tileKey;
        const values = controller.getItemFormattedValue(itemType, itemKey);
        const colors = this.getItemColor();
        this.firstValue = values.firstValue;
        this.firstValueColor = colors.firstValue;
        this.secondValue = values.secondValue;
        this.secondValueColor = colors.secondValue;
    }
    Validate() {
        if (isNullOrUndefined(this.controller)) {
            return;
        }
        const controller = this.controller;
        const itemType = this.tileType;
        const itemKey = this.tileKey;
        this.header = controller.getItemName(itemType, itemKey).toUpperCase();
        this.tooltip = controller.getItemTooltip(itemType, itemKey);
    }
    getItemColor() {
        if (isNullOrUndefined(this.controller)) {
            return null;
        }
        const controller = this.controller;
        const itemType = this.tileType;
        const itemKey = this.tileKey;
        const value = controller.getItemValue(itemType, itemKey);
        const strValue = controller.getItemFormattedValue(itemType, itemKey);
        if (strValue === null || strValue === void 0 ? void 0 : strValue.isNAString()) {
            return new RowItemDataColorArray(null, controller.getColoringMethod(itemType));
        }
        return new RowItemDataColorArray(value, controller.getColoringMethod(itemType));
    }
    updateController(groupType) {
        this.controller = AccountWidgetAccountDetailsPanelController.getDataSource(groupType);
    }
}
